<template>
    <div class="select-component">
        <b-select 
            :placeholder="placeholder"
            v-bind:value="value"
            :required="required"
            v-on:input="$emit('input', $event)">
            <option
                v-for="option in component.data.values"
                :value="option.value"
                :key="option.value">
                {{ option.label }}
            </option>
        </b-select>
    </div>
</template>

<script>

export default {
    name: 'Select',
    components: {
    },
    props: {
        component: Object,
        value: String,
        required: Boolean,
    },
    data: function () {
        return {
        }
    },
    methods: {

    },
    mounted(){

    },     
    computed: {
        placeholder () {
            return this.component.placeholder ?? 'Select an option'
        },
    }
}

</script>

<style>

</style>

